var AppQuestionnaireModule = (function () {
    function AppQuestionnaireModule() {
    }
    return AppQuestionnaireModule;
}());
export { AppQuestionnaireModule };



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/app-questionnaire.module.ts.pre-build-optimizer.js